export default __webpack_public_path__ + "static/media/animation-calling.fb84fa4d.gif";